<template>
  <div class="header">
    <div class="inner clearfix">
      <router-link :to="{ path: '/' }"><img class="logo" src="../assets/logo.png"/></router-link>
      <ul class="nav clearfix">
        <li><router-link :to="{ path: '/' }">首页</router-link></li>
        <li><router-link :to="{ path: '/about/profile' }">关于我们</router-link></li>
        <li><router-link :to="{ path: '/pro' }">公益项目</router-link></li>
        <li><router-link :to="{ path: '/new' }">新闻中心</router-link></li>
        <li><router-link :to="{ path: '/vol' }">志愿服务</router-link></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="scss" scope>
  @import '../scss/layouts/header';
</style>